import * as requestFromServer from "./DailyAttendanceReportCrud";
import { callTypes, dailyAttendanceReportSlice } from "./DailyAttendanceReportSlice";

const {actions} = dailyAttendanceReportSlice;

export const getDailyAttendanceReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getDailyAttendanceReport(queryParams)
    .then(response => {
      dispatch(actions.dailyAttendanceReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllDailyAttendanceReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllDailyAttendanceReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getAllList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllList()
    .then(response => {
      dispatch(actions.allListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getList = (term, sectionId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getList(term, sectionId)
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAdvisorsAndTeachers = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAdvisorsAndTeachers(term)
    .then(response => {
      dispatch(actions.advisorsAndTeachersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = (term, sectionId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getStudents(term, sectionId)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanStudentsState = () => dispatch => {
  dispatch(actions.studentsStateCleaned());
}

export const cleanDailyAttendanceReportState = () => dispatch => {
  dispatch(actions.dailyAttendanceReportStateCleaned());
}